"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformScienceTraceSchema = exports.PlatformScienceTraceBaseSchema = exports.PlatformScienceTracePollPageSchema = exports.PlatformScienceRawTraceSchema = exports.PLATFORM_SCIENCE_SOURCE_TYPE_BY_ASSET_TYPE = exports.PlatformScienceTraceSourceType = exports.PLATFORM_SCIENCE_TRACE_TYPE_BY_CODE = exports.PlatformScienceTraceType = void 0;
const zod_1 = require("zod");
const jsonValue_1 = require("../../jsonValue");
const platformScienceTraceFieldMaxLength_1 = require("./platformScienceTraceFieldMaxLength");
var PlatformScienceTraceType;
(function (PlatformScienceTraceType) {
    PlatformScienceTraceType["NAVIGATION_STARTED"] = "NAVIGATION_STARTED";
    PlatformScienceTraceType["NAVIGATION_CANCELED"] = "NAVIGATION_CANCELED";
    PlatformScienceTraceType["NAVIGATION_ETA_UPDATE"] = "NAVIGATION_ETA_UPDATE";
    PlatformScienceTraceType["NAVIGATION_DESTINATION_REACHED"] = "NAVIGATION_DESTINATION_REACHED";
    PlatformScienceTraceType["DRIVING_TIMES_STATE"] = "DRIVING_TIMES_STATE";
    PlatformScienceTraceType["FUEL_LEVEL_UPDATE"] = "FUEL_LEVEL_UPDATE";
})(PlatformScienceTraceType || (exports.PlatformScienceTraceType = PlatformScienceTraceType = {}));
exports.PLATFORM_SCIENCE_TRACE_TYPE_BY_CODE = {
    40: PlatformScienceTraceType.NAVIGATION_STARTED,
    41: PlatformScienceTraceType.NAVIGATION_CANCELED,
    42: PlatformScienceTraceType.NAVIGATION_ETA_UPDATE,
    43: PlatformScienceTraceType.NAVIGATION_DESTINATION_REACHED,
    82: PlatformScienceTraceType.DRIVING_TIMES_STATE,
    167: PlatformScienceTraceType.FUEL_LEVEL_UPDATE,
};
var PlatformScienceTraceSourceType;
(function (PlatformScienceTraceSourceType) {
    PlatformScienceTraceSourceType["TRUCK"] = "TRUCK";
    PlatformScienceTraceSourceType["MOBILE"] = "MOBILE";
    PlatformScienceTraceSourceType["UNKNOWN"] = "UNKNOWN";
})(PlatformScienceTraceSourceType || (exports.PlatformScienceTraceSourceType = PlatformScienceTraceSourceType = {}));
exports.PLATFORM_SCIENCE_SOURCE_TYPE_BY_ASSET_TYPE = {
    1: PlatformScienceTraceSourceType.TRUCK,
    5: PlatformScienceTraceSourceType.MOBILE,
};
exports.PlatformScienceRawTraceSchema = zod_1.z.object({
    type: zod_1.z.number().int(),
    source: zod_1.z.string().min(1).max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.SOURCE_EXTERNAL_ID),
    time: zod_1.z.string().datetime(),
    coordinate: zod_1.z.object({ latitude: zod_1.z.number(), longitude: zod_1.z.number() }).optional(),
    mileage: zod_1.z.number(),
    heading: zod_1.z.number(),
    speed: zod_1.z.number(),
    property: zod_1.z.array(zod_1.z.object({ key: zod_1.z.string(), value: zod_1.z.string() })),
});
exports.PlatformScienceTracePollPageSchema = zod_1.z.object({
    traces: zod_1.z.array(zod_1.z.record(zod_1.z.string(), jsonValue_1.JsonValueSchema)).default([]),
    mark: zod_1.z.string().min(1),
    more: zod_1.z.boolean(),
});
exports.PlatformScienceTraceBaseSchema = zod_1.z.object({
    source: zod_1.z.string().min(1).max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.SOURCE_EXTERNAL_ID),
    time: zod_1.z.string().datetime(),
    latitude: zod_1.z.number().nullable(),
    longitude: zod_1.z.number().nullable(),
    mileage: zod_1.z.number(),
    heading: zod_1.z.number(),
    speed: zod_1.z.number(),
    properties: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
});
const PropertyValueSchema = zod_1.z.string();
const COMMON_PROPERTIES = {
    ACY: PropertyValueSchema.optional(),
    FLA: PropertyValueSchema.optional(),
    LACY: PropertyValueSchema.optional(),
    LPOST: PropertyValueSchema.optional(),
    LLAT: PropertyValueSchema.optional(),
    LLON: PropertyValueSchema.optional(),
};
const NavigationDestinationShape = {
    ...COMMON_PROPERTIES,
    DLAT: PropertyValueSchema,
    DLON: PropertyValueSchema,
    TID: PropertyValueSchema.max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.TASK_ID).optional(),
};
const NavigationRouteShape = {
    ...NavigationDestinationShape,
    ETA: PropertyValueSchema,
    DIST: PropertyValueSchema,
    ROUTESET: PropertyValueSchema.max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.ROUTE_SETTINGS),
    TFD: PropertyValueSchema.optional(),
    SRC: PropertyValueSchema.max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.ROUTE_SOURCE).optional(),
    CPPROFILE: PropertyValueSchema.max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.COPILOT_PROFILE).optional(),
};
const PlatformScienceNavigationStartedTraceSchema = exports.PlatformScienceTraceBaseSchema.extend({
    type: zod_1.z.literal(PlatformScienceTraceType.NAVIGATION_STARTED),
    properties: zod_1.z.object(NavigationRouteShape).catchall(PropertyValueSchema),
});
const PlatformScienceNavigationEtaUpdateTraceSchema = exports.PlatformScienceTraceBaseSchema.extend({
    type: zod_1.z.literal(PlatformScienceTraceType.NAVIGATION_ETA_UPDATE),
    properties: zod_1.z.object(NavigationRouteShape).catchall(PropertyValueSchema),
});
const PlatformScienceNavigationCanceledTraceSchema = exports.PlatformScienceTraceBaseSchema.extend({
    type: zod_1.z.literal(PlatformScienceTraceType.NAVIGATION_CANCELED),
    properties: zod_1.z.object(NavigationDestinationShape).catchall(PropertyValueSchema),
});
const PlatformScienceNavigationDestinationReachedTraceSchema = exports.PlatformScienceTraceBaseSchema.extend({
    type: zod_1.z.literal(PlatformScienceTraceType.NAVIGATION_DESTINATION_REACHED),
    properties: zod_1.z.object(NavigationDestinationShape).catchall(PropertyValueSchema),
});
const PlatformScienceDrivingTimesStateTraceSchema = exports.PlatformScienceTraceBaseSchema.extend({
    type: zod_1.z.literal(PlatformScienceTraceType.DRIVING_TIMES_STATE),
    properties: zod_1.z
        .object({
        DID: PropertyValueSchema.max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.DRIVER_ID),
        CDTY: PropertyValueSchema,
        DSTAT: PropertyValueSchema.max(platformScienceTraceFieldMaxLength_1.PLATFORM_SCIENCE_TRACE_FIELD_MAX_LENGTH.DRIVING_STATISTICS),
        DTY: PropertyValueSchema.optional(),
        DST: PropertyValueSchema.optional(),
        AST: PropertyValueSchema.optional(),
        SST: PropertyValueSchema.optional(),
        ALEN: PropertyValueSchema.optional(),
        TFU: PropertyValueSchema.optional(),
        EMIL: PropertyValueSchema.optional(),
        ELAT: PropertyValueSchema.optional(),
        ELON: PropertyValueSchema.optional(),
        CTRY: PropertyValueSchema.optional(),
        DCPR: PropertyValueSchema.optional(),
        FLA: PropertyValueSchema.optional(),
        ACY: PropertyValueSchema.optional(),
    })
        .catchall(PropertyValueSchema),
});
const PlatformScienceFuelLevelUpdateTraceSchema = exports.PlatformScienceTraceBaseSchema.extend({
    type: zod_1.z.literal(PlatformScienceTraceType.FUEL_LEVEL_UPDATE),
    properties: zod_1.z
        .object({
        ...COMMON_PROPERTIES,
        FLP: PropertyValueSchema,
        FLC: PropertyValueSchema,
        TFU: PropertyValueSchema.optional(),
    })
        .catchall(PropertyValueSchema),
});
exports.PlatformScienceTraceSchema = zod_1.z.discriminatedUnion('type', [
    PlatformScienceNavigationStartedTraceSchema,
    PlatformScienceNavigationCanceledTraceSchema,
    PlatformScienceNavigationEtaUpdateTraceSchema,
    PlatformScienceNavigationDestinationReachedTraceSchema,
    PlatformScienceDrivingTimesStateTraceSchema,
    PlatformScienceFuelLevelUpdateTraceSchema,
]);
//# sourceMappingURL=platformScienceTrace.js.map